import { render } from "./PregnancyStories.vue?vue&type=template&id=2a24704a&scoped=true"
import script from "./PregnancyStories.vue?vue&type=script&lang=js"
export * from "./PregnancyStories.vue?vue&type=script&lang=js"

import "./PregnancyStories.vue?vue&type=style&index=0&id=2a24704a&scoped=true&lang=scss"
import "./PregnancyStories.vue?vue&type=style&index=1&id=2a24704a&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a24704a"]])

export default __exports__